import {
    ApplicationViewModel,
    PaymentViewModel,
    StateFeeRequirementViewModel
} from "@/api-client";

export class StateFeeSeafarerProps {
    constructor(
        public application: ApplicationViewModel, 
        public requirement: StateFeeRequirementViewModel, 
        public requirementValue: PaymentViewModel | null) {}
}

export class StateFeeOfficialProps {
    constructor(
        public application: ApplicationViewModel,
        public requirement: StateFeeRequirementViewModel) {}
}

export class PaymentDetailsProps {
    constructor(
        public payment: PaymentViewModel | null,
        public application: ApplicationViewModel,
        public requirement: StateFeeRequirementViewModel,
        public showUnconfirmedPaymentWarning: boolean,
        public showRefundCTA = false) {}
}